'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botManagerFilter = require('./bot-manager-filter.html');

var _botManagerFilter2 = _interopRequireDefault(_botManagerFilter);

var _botManagerFilter3 = require('./bot-manager-filter.controller');

var _botManagerFilter4 = _interopRequireDefault(_botManagerFilter3);

require('./bot-manager-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botManagerFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _botManagerFilter2.default,
  controller: _botManagerFilter4.default,
  controllerAs: 'vm'
};

exports.default = botManagerFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/bot-manager-filter/bot-manager-filter.component.js
 **/